import { ColorX } from 'framework/components/color/ColorX';
import { ArticlesInquiryStatusType } from 'gen/ApiClient';

export const ArticlesInquiryStatusTypeToColorXRecord: Record<ArticlesInquiryStatusType, ColorX> = {
	Assigned: 'success',
	PartialAssigned: 'warning',
	Unassigned: 'warning',
	Cancelled: 'error',
};
